import { ChangeDetectionStrategy, Component, Input, TrackByFunction } from '@angular/core'
import { DecoratedTextCellCommunicationService } from './decorated-text-cell-communication.service'

import type { IconModel, LinkModel, WebDecoratedTextCellModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-decorated-text-cell',
  templateUrl: './decorated-text-cell.component.html',
  styleUrls: ['./decorated-text-cell.component.scss', './styles/favorites-page-decorated-text-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DecoratedTextCellComponent {
  constructor(private readonly decoratedTextCellCommunicationService: DecoratedTextCellCommunicationService) {}

  @Input()
  item: WebDecoratedTextCellModel

  @Input() link?: LinkModel

  handleClick(link: LinkModel | undefined) {
    /** Should only emit when no link url, otherwise floCustomLinkDirective handles the click event (by routing) */
    if (link && !link.url) {
      this.decoratedTextCellCommunicationService.emitDecoratedTextCellLinkClick(link)
    }
  }

  // Track by to reduce DOM repainting as new options are dynamically loaded
  trackByStyle: TrackByFunction<IconModel> = (index: number, icon: IconModel) => {
    return icon.style
  }
}
